import {
  useWSModalCustom,
  WSForm,
  WSInputNumber,
  WSList,
  WSModal,
  WSModalCustomProps,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import * as Yup from "yup";

type FormData = { amount: number | null };

type Props = { count: number } & WSModalCustomProps<number | null>;

const ModalBulkSetAmount: React.FC<Props> = props => (
  <WSForm<FormData>
    onSubmit={formData => props.onClose(Number(formData.amount ?? 0))}
    defaultValues={{ amount: null }}
    validationSchema={Yup.object().shape({
      amount: Yup.number()
        .nullable()
        .required("Required")
        .moreThan(0, "Enter an amount")
    })}
  >
    <WSModal
      title="Set amount"
      size="S"
      onClose={() => props.onClose(null)}
      actions={{
        buttons: [
          {
            label: "Cancel",
            kind: "Secondary",
            type: "button",
            onClick: () => props.onClose(null)
          },
          { label: `Set ${props.count}` }
        ]
      }}
    >
      <WSList gap="M">
        <WSText color="gray500">
          Set the same amount on the {props.count} selected transactions.
        </WSText>
        <WSForm.Field
          name="amount"
          label="Amount"
          component={WSInputNumber}
          componentProps={{ min: 0, maxFractionDigits: 2, placeholder: "0.00" }}
        />
      </WSList>
    </WSModal>
  </WSForm>
);

export const useModalBulkSetAmount = () => useWSModalCustom(ModalBulkSetAmount);
